import { FeatureToggleClientService } from 'feature-toggle-client';
import { getTenant } from '../api/TenantApi';
import { DATABRICKS_STORAGE_TYPE_ENABLED } from 'shared/FeatureToggleKeys';
import { BillingMetrics } from 'shared/BillingMetrics';

export default class FeatureToggleService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static async isFeatureToggleEnabled(featureKey: string): Promise<any> {
    return FeatureToggleClientService.getInstance().isFeatureEnabled(featureKey);
  }

  static async isFeatureToggleEnabledByCluster(featureKey: string): Promise<boolean> {
    const feature = await FeatureToggleClientService.getInstance().isFeatureEnabled(featureKey);
    const tenant = await getTenant();
    const clusterName = tenant?.clusterName?.toLowerCase() ?? '';
    const clusterVariation = clusterName in feature ? clusterName : 'default';
    return  feature?.[clusterVariation]?.['isEnabled'] ?? true;
  }

  static async isDatabricksStorageTypeEnabled(metric: BillingMetrics): Promise<boolean> {   
    const databricksStorageTypeEnabled = await FeatureToggleService.isFeatureToggleEnabled(
      DATABRICKS_STORAGE_TYPE_ENABLED
    );

    const tenant = await getTenant();
    const clusterName = tenant?.clusterName?.toLowerCase() ?? '';

    const clusterVariation = clusterName in databricksStorageTypeEnabled ? clusterName : 'default';
    const metricVariation = metric in (databricksStorageTypeEnabled?.[clusterVariation] ?? {}) ? metric : null;

    let isEnabled = databricksStorageTypeEnabled?.[clusterVariation]?.['isEnabled'] ?? true;

    if (metricVariation) {
      isEnabled = databricksStorageTypeEnabled?.[clusterVariation]?.[metricVariation]?.['isEnabled'] ?? isEnabled;
    }

    return isEnabled;
  }

}
